<!-- eslint-disable vue/no-deprecated-v-on-native-modifier -->
<!--
 * @Description: 员工单条查找带回
 * @Author: PF
 * @Date: 2023-03-22 10:52:21
 * @LastEditors: PF
 * @LastEditTime: 2026-09-22 16:35:20
-->
<template>
  <div class="tan-chuang">
    <el-dialog style="min-width: 770px;" class="w900 hp70" :model-value="openDanTiao" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">教职工</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDanTiao', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-container>
        <el-header class="mb0 pl0 pr0 pb0">
          <!-- 搜索区域 BEGIN -->
          <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
            <el-form-item>
              <el-input placeholder="工号/姓名/身份证件号" v-model="dataGrid.parms.keyword" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                <template #suffix>
                  <el-icon class="el-input__icon pointer" @click="bindTable()">
                    <search />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-cascader placeholder="部门" v-model="dataGrid.parms.jgid" :options="jgTree" :props="{ checkStrictly: true, label: 'jgmc', value: 'id', children: 'children'}" clearable filterable @change="bindTable()" />
            </el-form-item>
            <el-form-item>
              <el-select placeholder="职务" v-model="dataGrid.parms.zwid" clearable filterable @change="bindTable()">
                <el-option v-for="item in zwData" :key="item.id" :label="item.zwmc" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-button type="success" @click="openGaoJiChaXunJiaoShi=true"><span class="el-icon--left iconfont icon-sousuo" :style="dataGrid.parms.gaoJiQuery?'color:#ff0':''"></span>高级查询</el-button>
          </el-form>
          <!-- 搜索区域 END -->
        </el-header>
        <el-main class="mb0 pl0 pr0 pb0">
          <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
            <!-- 冻结列-Left BEGIN -->
            <el-table-column label="" type="index" fixed align="center" width="50" />
            <el-table-column label="工号" prop="gh" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="姓名" prop="xm" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
              <span style="color: #409EFF;cursor: pointer;" @click="openDetail=true; tcrow=scope.row">{{scope.row.xm}}</span>
              </template>
            </el-table-column>
            <!-- 冻结列-Left END -->
            <el-table-column label="性别" prop="xb" align="center" />
            <el-table-column label="部门" prop="zygwjgmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="主要职务" prop="zygwzwmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="90" fixed="right" align="center">
              <template #default="scope">
                <el-button type="primary" size="small" @click="savestudent(scope.row)">选择</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
      </el-container>
      <template #footer>
        <div class="dialog-footer">
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
        </div>
      </template>
    </el-dialog>
    <detail v-if="openDetail" v-model:openDetail="openDetail" :row="tcrow" />
    <gaojichaxunjiaoshi v-if="openGaoJiChaXunJiaoShi" v-model:openGaoJi="openGaoJiChaXunJiaoShi" :row="dataGrid.parms.gaoJiQuery" @ReturnData="jiaoShiGaoJiRet" />
  </div>
</template>
<script setup>
import { ref, defineProps, watch, defineEmits } from 'vue'
import { closeWindow, loadSelect, loadList } from '@/api/common'
import { loadJiGouCascader } from '@/api/queryJiGou.js'
import pagination from '@/components/pagination.vue'
import detail from '@/components/jiaozhigong/detail'
import gaojichaxunjiaoshi from '@/components/gaojichaxun/jiaoshi.vue'

const props = defineProps({
  openDanTiao: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDanTiao', 'ReturnData'])

// 教师高级查询
const openGaoJiChaXunJiaoShi = ref(false)
const jiaoShiGaoJiRet = (data) => {
  dataGrid.value.parms = {}
  if (data.length !== 0) {
    dataGrid.value.parms.gaoJiQuery = data
  }
  bindTable()
}

// 加载 机构 级联下拉框
const jgTree = ref()
loadJiGouCascader(jgTree)

// 加载 职务 下拉框
const zwData = ref()
loadSelect({ url: '/api/v2/pdp/zhiwu/list', data: zwData })

// 列表
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {
    pagerCount: 5,
    pageSize: 20,
    layout: 'prev, pager, next, total'
  },
  loading: false,
  orderBy: { prop: 'gh', order: 'ascending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.parms.jgid = Array.isArray(dataGrid.value.parms.jgid)
    ? dataGrid.value.parms.jgid[dataGrid.value.parms.jgid.length - 1]
    : dataGrid.value.parms.jgid
  loadList({
    url: '/api/v2/pdp/jiaozhigong/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 20,
    pagerCount: 5,
    layout: 'prev, pager, next, total',
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}
watch(
  () => props.openDanTiao,
  () => {
    if (props.openDanTiao) {
      dataGrid.value.parms.jgid = props.row ? props.row.jgid : ''
      dataGrid.value.parms = props.row || {}
      bindTable()
    }
  },
  { deep: true, immediate: true }
)

const tcrow = ref()
const openDetail = ref(false)

const savestudent = (rwo) => {
  emits('ReturnData', rwo)
  closeWindow('openDanTiao', emits, false)
}

</script>
